import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import serverData from '../../utils/server-data'
// eslint-disable-next-line camelcase
export default class Subheader extends Component {
  handlePrintClick = e => {
    e.preventDefault()
    window.print()
  }

  render() {
    return (
      <section>
        <div className="template-print-container">
          <img
            id="print_pic"
            src={`https://${serverData.cdnHost}/webstatic/ua/printer_icon.jpg`}
          />
          <a className="template-print-icon" onClick={this.handlePrintClick}>
            <Message id="app.default.subheader.print" />
          </a>
        </div>
      </section>
    )
  }
}
